import script from "./StudioEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioEditModal.vue?vue&type=script&setup=true&lang=js"

import "./StudioEditModal.vue?vue&type=style&index=0&id=45850672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45850672"]])

export default __exports__